import { IconButton } from '@mui/material';
import { GridDensity, gridDensitySelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid-pro';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import { AppLocalStorageKeys } from '@/Infrastructure/Configuration/types';

import styles from '../Dispatch/DataGrid.Dispatch.module.css';

export const DENSITY_OPTIONS: { value: GridDensity; label: string; icon: typeof DensitySmallIcon }[] = [
  { value: 'compact', label: 'Compact', icon: DensitySmallIcon },
  { value: 'standard', label: 'Standard', icon: DensityMediumIcon }
];

export default function DensityMenuButton() {
  const apiRef = useGridApiContext();
  const density = useGridSelector(apiRef, gridDensitySelector);
  const isCompact = density === 'compact';
  const Icon = isCompact ? DensitySmallIcon : DensityMediumIcon;

  const toggleDensity = () => {
    const nextDensity: GridDensity = isCompact ? 'standard' : 'compact';
    localStorage.setItem(AppLocalStorageKeys.GridDensity, nextDensity);
    apiRef.current.setDensity(nextDensity);
  };

  return (
    <IconButton
      title={isCompact ? 'Compact' : 'Standard'}
      onClick={toggleDensity}
      className={`${styles['icon-btn']} ${styles['density-btn']}`}>
      <Icon />
    </IconButton>
  );
}
